import { RESOURCE_CENTER_PATH } from '@sly/core/constants/dashboardAppPaths';
import cx from 'classnames';
import { array, bool, string } from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import Chevron from 'sly/icons/Chevron';
import ArticlePreview from 'sly/resourceCenter/components/ArticlePreview';
import Heading from 'sly/system/Heading';
import Link from 'sly/system/Link';

const hideOnTabletStyles = 'md:hidden lg:block';

const ArticlesList = ({
  topic,
  withRedirectToTopicPage,
  articlesTitle,
  articles,
}) => {
  const hrefToTopicPage = useMemo(
    () => `${RESOURCE_CENTER_PATH}/${topic}`,
    [topic]
  );

  const getHrefToArticlePage = useCallback(
    (slug, internalTopic) => `${RESOURCE_CENTER_PATH}/${internalTopic}/${slug}`,
    []
  );

  if (articles?.length == 0) {
    return null;
  }

  return (
    <div
      className='mx-auto w-auto md:w-[42.5rem] lg:w-[64.5rem]'
      data-tp-id='gen-Block-11a50ca7-f6fe-4161-9c06-58cc6a302f49'
    >
      <div
        className='mb-l ml-m md:ml-0 md:flex md:items-end md:justify-between'
        data-tp-id='gen-Block-17b6c4ef-89e9-4813-a669-a35bf97e86c1'
      >
        <Heading
          font='title-large'
          className={cx(
            'w-max',
            withRedirectToTopicPage ? 'mb-xs' : 'mb-0',
            'font-t-l'
          )}
          data-tp-id='gen-Heading-94dd2123-6718-47a6-9125-4b84122955ae'
        >
          {articlesTitle}
        </Heading>
        {withRedirectToTopicPage && (
          <Link
            className='font-b-l block md:text-left'
            to={hrefToTopicPage}
            data-tp-id='gen-Link-66ae889f-1d06-4ccc-b70c-f4453a6b9448'
          >
            See all {articlesTitle}
            <Chevron className='rotate-90' />
          </Link>
        )}
      </div>
      <div
        className={cx(
          'grid w-full overflow-auto',
          'gap-m px-m',
          'md:pl-0 md:pr-0',
          'md:overflow-[unset] md:gap-l',
          'grid-cols-[repeat(auto-fill,_minmax(17.5rem,1fr))]',
          'auto-cols-[minmax(17.5rem,1fr)] grid-flow-col',
          'md:grid-cols-[repeat(auto-fill,_minmax(20.5rem,1fr))]',
          'grid-flow-col md:auto-cols-[minmax(20.5rem,1fr)]',
          'overflow-x-auto'
        )}
        data-tp-id='gen-Grid-f6e47ce2-4882-4650-98cc-ea887f446497'
      >
        {articles?.map(
          (
            { mainImg, title, shortDescription, slug, mainTopic, tagsList, id },
            index
          ) => (
            <ArticlePreview
              {...{
                smallSizeOnPhone: true,
                topic: mainTopic,
                path: mainImg?.path,
                alternativeText: mainImg?.alternativeText,
                title,
                shortDescription,
                tagsList,
                to: getHrefToArticlePage(slug, mainTopic?.slug),
                key: id,
                ...(index > 1 && { customStyles: hideOnTabletStyles }),
              }}
              key={id}
            />
          )
        )}
        {articles?.length > 1 && (
          <div
            className='md:hidden'
            data-tp-id='gen-Block-d45195ec-6f6f-4e20-8621-15c16d5c9a4c'
          />
        )}
      </div>
    </div>
  );
};

ArticlesList.propTypes = {
  topic: string,
  withRedirectToTopicPage: bool,
  articlesTitle: string,
  articles: array,
};

export default ArticlesList;
